import { render, staticRenderFns } from "./passWdReset.vue?vue&type=template&id=1111b260&scoped=true"
import script from "./passWdReset.vue?vue&type=script&lang=js"
export * from "./passWdReset.vue?vue&type=script&lang=js"
import style0 from "./passWdReset.vue?vue&type=style&index=0&id=1111b260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111b260",
  null
  
)

export default component.exports